module.exports = __webpack_public_path__ + "assets/images/project/constituencies/tampines-grc.jpg?v=51c175cc";